import { render, staticRenderFns } from "./reviseRecord.vue?vue&type=template&id=43be0d86&"
import script from "./reviseRecord.vue?vue&type=script&lang=js&"
export * from "./reviseRecord.vue?vue&type=script&lang=js&"
import style0 from "./reviseRecord.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports